import { render, staticRenderFns } from "./SubjectList.vue?vue&type=template&id=33770edc"
import script from "./SubjectList.vue?vue&type=script&lang=js"
export * from "./SubjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports